module.exports = __webpack_public_path__ + "static/media/default_user_picture.7ea4af7d.png";